/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 12.06.13, 12:55
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

export class GGSTextDecoration {
    public static NONE: string = "none";
    public static UNDERLINE: string = "underline";
}
